import { IconType } from '../../components/Sidebar/IconHelper';
import { getModelIconConfig } from '../../utils/ModelIconMapping';

export type GlobalSearchResultType =
  | 'Contact'
  | 'Investor'
  | 'FundOpportunity'
  | 'AdminUser'
  | 'InvestmentEntity'
  | 'Article';

export interface GlobalSearchResult {
  id: string;
  type: GlobalSearchResultType;
  label: string;
  subtitle?: string;
}

// Map GlobalSearchResultType to ModelType for icon consistency
const globalSearchToModelTypeMap: Record<GlobalSearchResultType, string> = {
  Contact: 'CONTACT',
  Investor: 'INVESTOR',
  FundOpportunity: 'FUND_OPPORTUNITY',
  AdminUser: 'ADMIN_USER',
  InvestmentEntity: 'INVESTMENT_ENTITY',
  Article: 'ARTICLE',
};

export const globalSearchIconTypeMap: Record<string, IconType> = {
  FundOpportunity: 'Funds',
  FundUpdate: 'Portfolio',
  Contact: 'Contact',
  AdminUser: 'Admin',
  InvestmentEntity: 'Portfolio',
  Article: 'News',
  Message: 'Chat',
  Home: 'Home', // optionally used for dashboard/root results
};

// New function to get model icon for global search results
export const getGlobalSearchModelIcon = (type: GlobalSearchResultType) => {
  const modelType = globalSearchToModelTypeMap[type];
  if (modelType) {
    return getModelIconConfig(modelType);
  }
  return null;
};
